import { render, staticRenderFns } from "./MultiManuscriptEditorFooter.vue?vue&type=template&id=5aba46fd&scoped=true"
import script from "./MultiManuscriptEditorFooter.vue?vue&type=script&lang=ts"
export * from "./MultiManuscriptEditorFooter.vue?vue&type=script&lang=ts"
import style0 from "./MultiManuscriptEditorFooter.vue?vue&type=style&index=0&id=5aba46fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba46fd",
  null
  
)

export default component.exports